<template>
    <div class="articles">
        <div class="article" v-for="(project, index) in projectList" :key="index">
            <div class="photo-box">
                <div class="like" @click="changeLikeStatus(project.id)">
                    <svg class="like-item" v-if="isProjectLiked(project.id)" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512">
                        <path
                            d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" />
                    </svg>
                    <svg class="like-item" v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                            d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z" />
                    </svg>
                </div>
                <router-link to="project-details"><img class="photo" :src="project.img" alt="photo"></router-link>
            </div>
            <div class="article-text">
                <div>
                    <router-link to="project-details">
                        <h3 class="heading">{{ project.heading }}</h3>
                    </router-link>
                    <a href="project.links[0].link" class="text">{{ project.links[0].name }}</a> /
                    <a href="project.links[1].link" class="text">{{ project.links[1].name }}</a>
                </div>
                <router-link to="project-details">
                    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="35" cy="35" r="35" fill="#F4F0EC" />
                        <path d="M32 44L40 35L32 26" stroke="#292F36" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg></router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'OurProjectsBox',
    props: ['projectList'],
    data() {
        return {
            favoriteList: []
        }
    },
    created() {
        this.inizializeFavoriteList();
        this.checkLocalStorage();
        this.restoreFavoriteProject();
    },
    computed: {
        ...mapState(['projects'])
    },
    methods: {
        inizializeFavoriteList() {
            this.favoriteList = this.projects.map(item => ({
                'id': item.id,
                'isLiked': false
            }))
        },

        checkLocalStorage() {
            if (!localStorage.getItem('likeProjectData')) {
                localStorage.setItem('likeProjectData', '[]');
            }
        },

        restoreFavoriteProject() {
            const likeList = JSON.parse(localStorage.getItem('likeProjectData')); // восстанавливаем отмеченные проекты по данным Local Storage
            if (likeList.length) {
                this.favoriteList.forEach(item => item.isLiked = likeList.includes(item.id));
            }
        },

        changeLikeStatus(projectID) {
            this.favoriteList.forEach(item => {
                if (item.id === projectID) {
                    item.isLiked = !item.isLiked;
                }
            })

            const likeList = this.favoriteList.filter(item => item.isLiked).map(item => item.id);
            this.sincLikeDataLocalStorage(likeList);
        },

        sincLikeDataLocalStorage(likeData) {
            localStorage.setItem('likeProjectData', JSON.stringify(likeData))
        },

        isProjectLiked(projectID) {
            return this.favoriteList.find(item => item.id === projectID).isLiked;
        },
    }

}</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=Jost:wght@100;400&display=swap');
@import "../assets/_variables";

.center {
    padding-left: calc(50% - 580px);
    padding-right: calc(50% - 580px);
}

.indent-back-button {
    margin-top: 90px;
}

.articles {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;

    .article {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-weight: 400;
        position: relative;

        &-text {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin: 10px 0;

            svg {
                transition: transform 0.1s ease-in;
            }

            svg:hover {
                transform: scale(1.2);
            }
        }

        .photo-box {
            width: 100%;
            transition: transform 0.1s ease-in;

            .photo {
                width: 100%;
            }

            .like {
                position: absolute;
                right: 15px;
                top: 15px;

                &-item {
                    width: 35px;
                    cursor: pointer;
                    padding: 15px;
                    transition: transform 0.1s ease-in;
                }
            }

            &:hover {
                transform: scale(1.02);
                box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;

                & .like:hover {
                    transform: scale(1.2);
                }

            }
        }

        .heading {
            color: #292F36;
            font-family: $fontSerif;
            font-size: 25px;
            letter-spacing: 0.5px;
            margin-bottom: 7px;
        }

        .text {
            color: #4D5053;
            font-family: Jost;
            font-size: 22px;
            letter-spacing: 0.22px;
            text-decoration: none;
        }
    }

    a {
        text-decoration: none;
    }
}
</style>